import { TERMINOLOGY_TOKENS } from "@app/shared/terminology/terminology-token.catalog";
import { defineTerminologyUsage, TerminologyTokenDefinition, TerminologyUsageKind, TERMINOLOGY_CONFIGURATION_CODES, TERMINOLOGY_USAGE_KINDS } from "@app/shared/terminology/terminology-usage";

const usage = (name: string, token: TerminologyTokenDefinition, fallbackText: string, kind: TerminologyUsageKind) => defineTerminologyUsage({
  usageId: `phms.pre-hearing.participant-roster.${name}`, token, fallbackText, kind,
  configurationCode: TERMINOLOGY_CONFIGURATION_CODES.programPack,
  surface: {
    featureCode: "phms", surfaceCode: "pre-hearing-participant-roster",
    componentCode: "PreHearingVictimNotificationSectionComponent",
    locations: [{ kind: "route", value: "/phms/hearing-detail" }],
  },
});

/** Notice vocabulary is shared with scheduling; roster actions have their own usage identity. */
export const PRE_HEARING_PARTICIPANT_ROSTER_TERMINOLOGY = {
  officialPicker: usage("official-picker", TERMINOLOGY_TOKENS.hearingOfficial, "Parole Official", TERMINOLOGY_USAGE_KINDS.formLabel),
  noticeAction: usage("notice-action", TERMINOLOGY_TOKENS.noticeRecord, "Notice", TERMINOLOGY_USAGE_KINDS.actionLabel),
  firstName: usage("first-name", TERMINOLOGY_TOKENS.queueColumnFirstName, "FIRST NAME", TERMINOLOGY_USAGE_KINDS.formLabel),
  lastName: usage("last-name", TERMINOLOGY_TOKENS.queueColumnLastName, "LAST NAME", TERMINOLOGY_USAGE_KINDS.formLabel),
  noticeHistory: usage("notice-history", TERMINOLOGY_TOKENS.noticeHistory, "Notice History", TERMINOLOGY_USAGE_KINDS.templateText),
  noticePrepare: usage("notice-prepare", TERMINOLOGY_TOKENS.noticeRecordInline, "notice", TERMINOLOGY_USAGE_KINDS.actionLabel),
  noticeRelated: usage("notice-related", TERMINOLOGY_TOKENS.noticeRecordInline, "notice", TERMINOLOGY_USAGE_KINDS.formLabel),
  noticeWording: usage("notice-wording", TERMINOLOGY_TOKENS.noticeRecordInline, "notice", TERMINOLOGY_USAGE_KINDS.actionLabel),
} as const;
